import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
  useRef,
} from 'react';
import './index.module.less';

import BrowserHistory from '@helpers/BrowserHistory';
import { isCubeApp, locationType, deviceStatus } from '@helpers/Constants';
import NativeInterface from '@helpers/NativeInterface';
import FridayService from '@services/friday';
import { calcCustomDateText } from './util';

import Toast from '@widgets/Toast';
import ConfirmModal from '@components/ConfirmModal';
interface IProps {
  devicePosition: any;
  currentDevice: any;
  deviceInfo: any;
  onRefresh: () => void;
  animation: boolean;
}

const Card = (props: IProps, ref: any) => {
  const { currentDevice, devicePosition, deviceInfo } = props;
  const [showPopup, displaySettingPopup] = useState(false);
  const isBodyListener = useRef(null);
  const getCellCapacityTexts = () => {
    const value = deviceInfo?.electricityRate;
    if (!value) {
      return '';
    }
    const num = Number(value.split('%')[0]);
    let styleColor = '#6BB247';
    if (num <= 20) {
      styleColor = '#FF8026';
    }
    return <span style={{ color: styleColor }}>电量{value}</span>;
  };

  const toJumpDevicePage = () => {
    setTimeout(() => {
      BrowserHistory.push(
        `${PUBLIC_URL}/myDevices?selectedDeviceSN=${currentDevice?.snCode}`,
      );
    }, 100);
  };

  const toJumpPage = async () => {
    FridayService.addEvent('real_time_positioning_security_guard_click');
    if (isCubeApp()) {
      if (deviceInfo?.status === deviceStatus.locked) {
        return ConfirmModal.show({
          title: '设备已锁定',
          text:
            '设备插入的SIM卡不是服务商提供，因此设备已被锁定，解锁请插入服务商提供的SIM卡，并确认SIM卡可正常使用。',
          confirmBtnText: '我知道了',
        });
      }
      if (deviceInfo?.status === deviceStatus.forbid) {
        return ConfirmModal.show({
          title: '设备已禁用',
          text: '设备已被服务商禁用，请联系服务商解除。',
          confirmBtnText: '我知道了',
          confirmBtnStyle: { backgroundColor: '#F2F4F7', color: '#55585C' },
        });
      }
      if (deviceInfo?.isOnLine) {
        FridayService.addEvent('security_guard_self_show', {
          source: '实时定位',
        });
        NativeInterface.jumpNative({
          path: '/device/safeArea',
          extras: { deviceId: currentDevice?.snCode },
        });
      } else {
        Toast.show({
          type: 'strip',
          title: '设备离线，请联网后设置',
        });
      }
    }
  };

  const getIconName = () => {
    let iconName = 'icon-position';
    if (devicePosition?.locationType) {
      switch (devicePosition.locationType) {
        case locationType.gps:
          iconName = 'icon-weixing';
          break;
        case locationType.wifi:
          iconName = 'icon-wifi';
          break;
        case locationType.lbs:
          iconName = 'icon-jizhan';
          break;
        //no default
      }
    }
    return iconName;
  };

  const toDevicePage = (event: any) => {
    FridayService.addEvent('positioning_more_click_device_management');
    displaySettingPopup(!showPopup);
    event.stopPropagation();
    if (isCubeApp()) {
      NativeInterface.jumpNative({
        path: '/device/myDevice',
        extras: { selectedDeviceSN: currentDevice?.snCode },
      });
    } else {
      BrowserHistory.push(
        `${PUBLIC_URL}/myDevices?selectedDeviceSN=${currentDevice?.snCode}`,
      );
    }
  };

  const toLocationSettingPage = () => {
    if (deviceInfo?.status === deviceStatus.locked) {
      return ConfirmModal.show({
        title: '设备已锁定',
        text:
          '设备插入的SIM卡不是服务商提供，因此设备已被锁定，解锁请插入服务商提供的SIM卡，并确认SIM卡可正常使用。',
        confirmBtnText: '我知道了',
      });
    }
    if (deviceInfo?.status === deviceStatus.forbid) {
      return ConfirmModal.show({
        title: '设备已禁用',
        text: '设备已被服务商禁用，请联系服务商解除。',
        confirmBtnText: '我知道了',
        confirmBtnStyle: { backgroundColor: '#F2F4F7', color: '#55585C' },
      });
    }
    displaySettingPopup(false);
    FridayService.addEvent(
      'real_time_positioning_more_positioning_settings_display',
      { source: '更多_定位设置' },
    );
    setTimeout(() => {
      BrowserHistory.push(
        `${PUBLIC_URL}/locationsetting?sncode=${currentDevice?.snCode}&company=${currentDevice?.company}`,
      );
    }, 100);
  };

  const toPathPage = () => {
    setTimeout(() => {
      BrowserHistory.push(
        `${PUBLIC_URL}/movepath?sncode=${currentDevice?.snCode}&company=${currentDevice?.company}`,
      );
    }, 100);
    FridayService.addEvent('real_time_positioning_view_track_click');
  };

  const refreshData = () => {
    FridayService.addEvent('real_time_positioning_update_targeting_click');
    props.onRefresh && props.onRefresh();
  };

  useImperativeHandle(ref, () => ({
    displaySetting: () => {
      displaySettingPopup(!showPopup);
    },
    showPopup,
    hiddenPopUp: () => displaySettingPopup(false),
  }));

  const hiddenPopUp = () => {
    displaySettingPopup(false);
  };

  const deviceStatusText = (status: number) => {
    switch (status) {
      case deviceStatus.forbid:
        return <span>已禁用</span>;

      case deviceStatus.locked:
        return <span>已锁定</span>;

      case deviceStatus.online:
        return (
          <>
            {getCellCapacityTexts()}
            <span style={{ color: '#8D9199' }}>在线</span>
          </>
        );

      case deviceStatus.offline:
        return <span>{!deviceInfo ? '' : '离线'}</span>;

      default:
        break;
    }
  };

  useEffect(() => {
    if (!isBodyListener.current) {
      isBodyListener.current = true;
      window.addEventListener('click', hiddenPopUp, false);
    }
    return () => {
      if (isBodyListener.current) {
        window.removeEventListener('click', hiddenPopUp, false);
      }
    };
  }, []);
  return (
    <div styleName="content">
      <div className="flex" styleName="content-wrapper">
        <div styleName="content-info">
          <div className="els" styleName="content-info-title">
            {(currentDevice?.bindUserName ||
              '学生证' + (currentDevice?.snCode || '').slice(-4)) + '的定位'}
          </div>
          <div styleName="content-device-status">
            {deviceStatusText(deviceInfo?.status)}
            {devicePosition?.timestamp
              ? calcCustomDateText(devicePosition?.timestamp)
              : ''}
          </div>
        </div>
        <div
          styleName={'btn-refresh ' + (props.animation ? 'rotate' : '')}
          className="flex flex-center"
          onClick={refreshData}
        >
          <i className="iconfont icon-shuaxin" />
        </div>
      </div>
      <div className="flex" styleName="content-address">
        <i
          className={'flex iconfont ' + getIconName()}
          styleName="icon-addresss"
        />
        <span className="els">{devicePosition?.address || '暂无定位'}</span>
      </div>

      <div className="flex" styleName="bottom-btns">
        <div
          className="flex flex-center"
          styleName="bottom-item"
          onClick={toPathPage}
        >
          <i
            className="iconfont icon-guiji"
            styleName="item-icon"
            style={{ color: '#2AB1CC' }}
          />
          查看轨迹
        </div>
        <div
          className="flex flex-center"
          styleName="bottom-item"
          onClick={isCubeApp() ? toJumpPage : toJumpDevicePage}
        >
          {isCubeApp() ? (
            <i
              className="iconfont icon-anquanshouhu"
              styleName="item-icon"
              style={{ color: '#6BB247' }}
            />
          ) : (
            <i
              className="iconfont icon-xueshengzheng"
              styleName="item-icon"
              style={{ color: '#689BFF' }}
            />
          )}
          {isCubeApp() ? '安全守护' : '设备管理'}
        </div>
        <div
          className="flex flex-center"
          styleName="bottom-setting"
          onClick={event => {
            event.stopPropagation();
            event.preventDefault();
            displaySettingPopup(!showPopup);
          }}
        >
          <i className="iconfont icon-gengduo" styleName="item-icon" />
          {showPopup ? (
            <div styleName="setting-popup">
              <div
                className="flex flex-center"
                styleName="setting-popup-item"
                onClick={toLocationSettingPage}
              >
                <i
                  className="iconfont icon-dingwei1"
                  styleName="item-icon"
                  style={{ color: '#6BB247' }}
                />
                <span>定位设置</span>
              </div>
              {isCubeApp() ? (
                <>
                  <div className="flex flex-center">
                    <span styleName="setting-sep"></span>
                  </div>
                  <div
                    className="flex flex-center"
                    styleName="setting-popup-item"
                    onClick={toDevicePage}
                  >
                    <i
                      className="iconfont icon-xueshengzheng"
                      styleName="item-icon"
                    />
                    <span>设备管理</span>
                  </div>
                </>
              ) : null}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default forwardRef(Card);
